import getApiInstance from '@/api';
import { Loadable } from '@/components/Loadable';
import {
  getConsents,
  getSalesPointConfiguration,
  setTenant,
} from '@/features/configuration/configurationActions';
import { getProfile } from '@/features/profile/profileActions';
import { useDispatch } from '@/store/utils';
import { TENANT_OPTIONS } from '@/utils/tenant';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface AppLoaderProps {
  children: ReactNode;
}

const AppLoader = ({ children }: AppLoaderProps) => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      const promises = [];
      const tenant =
        TENANT_OPTIONS.find(
          ({ value }) => value === import.meta.env.VITE_APP_TENANT
        ) ?? TENANT_OPTIONS[0];

      await getApiInstance();

      promises.push(
        dispatch(getSalesPointConfiguration()),
        dispatch(getConsents()),
        dispatch(getProfile()),
        dispatch(setTenant(tenant))
      );

      await Promise.all(promises);

      setIsInitialized(true);
    };

    initialize();
  }, [dispatch]);

  return (
    <Loadable loading={!isInitialized} className={{ regular: 'h-screen' }}>
      {children}
    </Loadable>
  );
};

export default AppLoader;
